import Image from 'next/image'

export default function RevenueGrowthSection() {
  return (
    <section className='mx-auto grid grid-cols-12 gap-5 px-4 py-10 md:px-16 md:py-20'>
      <div className='col-span-12 md:col-span-5 md:flex md:flex-col md:justify-between'>
        <div className='text-heading-6 md:text-heading-2 leading-tight text-black'>
          Tăng trưởng doanh số
        </div>
        <div className='mt-2 text-base text-black md:text-2xl'>
          <div>
            Coolmate duy trì đà tăng trưởng mạnh mẽ, mở rộng danh mục sản phẩm
            và nâng cao trải nghiệm khách hàng, góp phần thúc đẩy doanh số bứt
            phá
          </div>
          <div className='mt-2 grid grid-cols-2 gap-3 md:mt-6 md:gap-5'>
            <div className='flex flex-col gap-2 rounded-3xl bg-gradient-to-br from-[#1A1A1A] to-[#3D3D3D] px-4 py-3 text-white md:px-8 md:py-6'>
              <div className='font-criteria text-sm font-medium md:text-lg'>
                Doanh thu 2025
              </div>
              <div className='flex flex-col gap-1'>
                <div className='text-xs italic md:text-sm'>Tăng</div>
                <div className='flex items-end gap-1'>
                  <div className='text-heading-4 md:text-heading-1 leading-[0.8]'>
                    2.2
                  </div>
                  <div className='text-sm md:text-base'>lần</div>
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-2 rounded-3xl bg-gradient-to-br from-[#1A1A1A] to-[#3D3D3D] px-4 py-3 text-white md:px-8 md:py-6'>
              <div className='font-criteria text-sm font-medium md:text-lg'>
                Tăng trưởng hàng năm tới năm 2030
              </div>
              <div className='flex items-end'>
                <div className='text-heading-4 md:text-heading-1 !font-medium leading-[0.8]'>
                  60
                </div>
                <div className='font-criteria text-2xl leading-none md:text-4xl'>
                  %
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-span-12 md:col-span-7 md:flex md:items-end'>
        <Image
          src='https://mcdn.coolmate.me/image/March2025/mceclip2_19.png'
          alt='Revenue Growth'
          width={1000}
          height={1000}
          className='w-full md:object-contain'
        />
      </div>
    </section>
  )
}
